import React, { Children } from 'react';
import { Helmet } from 'react-helmet-async';
type SEOHeadProps = {
  title?: string;
  description?: string;
  canonical?: string;
  structuredData?: object;
  ogImage?: string;
  ogType?: string;
};
export const SEOHead = ({
  title = 'Story Bunny - AI-Powered Stories for Children',
  description = 'Create magical AI-powered stories for children ages 3-6. Turn imagination into beautifully illustrated storybooks with safe, child-friendly AI technology.',
  canonical,
  structuredData,
  ogImage = 'https://storybunny.ai/og-image.jpg',
  ogType = 'website'
}: SEOHeadProps) => {
  const fullTitle = title.includes('Story Bunny') ? title : `${title} | Story Bunny`;
  return <Helmet data-id="element-806">
      <title data-id="element-807">{fullTitle}</title>
      <meta name="description" content={description} data-id="element-808" />
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} data-id="element-809" />
      <meta property="og:description" content={description} data-id="element-810" />
      <meta property="og:type" content={ogType} data-id="element-811" />
      <meta property="og:image" content={ogImage} data-id="element-812" />
      <meta property="og:site_name" content="Story Bunny" data-id="element-813" />
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-814" />
      <meta name="twitter:title" content={fullTitle} data-id="element-815" />
      <meta name="twitter:description" content={description} data-id="element-816" />
      <meta name="twitter:image" content={ogImage} data-id="element-817" />
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} data-id="element-818" />}
      {/* Structured Data */}
      {structuredData && <script type="application/ld+json" data-id="element-819">
          {JSON.stringify(structuredData)}
        </script>}
      {/* Additional SEO meta tags */}
      <meta name="robots" content="index, follow" data-id="element-820" />
      <meta name="author" content="Story Bunny AI LLC" data-id="element-821" />
      <meta name="keywords" content="AI stories, children's books, storytelling, kids creativity, educational technology, safe AI for kids" data-id="element-822" />
    </Helmet>;
};